function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Action, Streaming, Placeholder } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ポータル追加モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
})(Mode || (Mode = {}));
/**
 * 会議ストリーミング追加モーダルコンポーネント
 */


var SessionStreamingModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionStreamingModalComponent, _React$Component);

  var _super = _createSuper(SessionStreamingModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionStreamingModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionStreamingModalComponent);

    _this = _super.call(this, props);
    var limitSeconds = _this.props.monthlyLimitUpTime;
    var limitHours = Math.floor(_this.props.monthlyLimitUpTime / 3600);
    var limitMinutes = Math.floor((_this.props.monthlyLimitUpTime - limitHours * 3600) / 60);
    var limitSeconds = _this.props.monthlyLimitUpTime - limitHours * 3600 - limitMinutes * 60;
    var paddedLimitHours = ("00" + String(limitHours)).slice(-2);
    var paddedLimitMinutes = ("00" + String(limitMinutes)).slice(-2);
    var paddedLimitSeconds = ("00" + String(limitSeconds)).slice(-2);
    var seconds = _this.props.monthlyLimitUpTime - _this.props.monthlyTotalUpTime;
    var paddedHours = "00";
    var paddedMinutes = "00";
    var paddedSeconds = "00";

    if (seconds > 0) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - hours * 3600) / 60);
      var seconds = seconds - hours * 3600 - minutes * 60;
      paddedHours = ("00" + String(hours)).slice(-2);
      paddedMinutes = ("00" + String(minutes)).slice(-2);
      paddedSeconds = ("00" + String(seconds)).slice(-2);
    }

    var monthlyTotalUpTime = "".concat(paddedHours, ":").concat(paddedMinutes, ":").concat(paddedSeconds);
    var monthlyLimitUpTime = "".concat(paddedLimitHours, ":").concat(paddedLimitMinutes, ":").concat(paddedLimitSeconds);
    var canStreaming = _this.props.monthlyTotalUpTime < _this.props.monthlyLimitUpTime;

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          StreamingLocation: "",
          MonthlyTotalUpTime: monthlyTotalUpTime,
          MonthlyLimitUpTime: monthlyLimitUpTime,
          CanStreaming: canStreaming,
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    return _this;
  }
  /**
   * 配信場所を更新します。
   *
   * @param e イベント
   */


  _createClass(SessionStreamingModalComponent, [{
    key: "updateStreamingLocation",
    value: function updateStreamingLocation(e) {
      this.setState({
        StreamingLocation: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var materialFileName = this.state.StreamingLocation + ".Stream";
        this.props.onEntry(this.props.sessionId, materialFileName);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#StreamingDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "StreamingDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_360streaming_grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Streaming.AddTitle))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "StreamingLocation"
      }, intl.format(Label.StreamingLocation)), this.state.CanStreaming && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "StreamingLocation",
        id: "Name",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this3.updateStreamingLocation(e);
        },
        value: this.state.StreamingLocation,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.StreamingLocation)
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "StreamingLocation",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), !this.state.CanStreaming && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        style: {
          opacity: "0.5"
        },
        name: "StreamingLocation",
        id: "Name",
        disabled: true,
        value: intl.format(Streaming.StreamingWarning),
        tabIndex: 101
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }, intl.format(Label.RemainingStreamingTime)), this.state.CanStreaming && /*#__PURE__*/React.createElement("label", {
        className: "col-9 col-form-label"
      }, /*#__PURE__*/React.createElement("span", null, this.state.MonthlyTotalUpTime), " / ", /*#__PURE__*/React.createElement("span", null, this.state.MonthlyLimitUpTime)), !this.state.CanStreaming && /*#__PURE__*/React.createElement("label", {
        className: "col-9 col-form-label"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "red"
        }
      }, this.state.MonthlyTotalUpTime), " / ", /*#__PURE__*/React.createElement("span", null, this.state.MonthlyLimitUpTime))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }), /*#__PURE__*/React.createElement("span", {
        className: "col-9"
      }, intl.format(Streaming.Description_1)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }), /*#__PURE__*/React.createElement("span", {
        className: "col-9"
      }, intl.format(Streaming.Description_2)))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Back)), this.state.CanStreaming && this.state.StreamingLocation && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Generate)), !(this.state.CanStreaming && this.state.StreamingLocation) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        disabled: true,
        tabIndex: -1
      }, intl.format(Action.Generate))))));
    }
  }]);

  return SessionStreamingModalComponent;
}(React.Component);

export { SessionStreamingModalComponent as default };